import { CalendarModule } from 'angular-calendar';
import { LoadingModule } from './shared/loading/loading.module';

import { LoaderInterceptor } from './core/helpers/loading.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from '../environments/environment';

import { NgbNavModule, NgbAccordionModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { NgxScrollTopModule  } from 'ngx-scrolltop';

import { SharedModule } from './cyptolanding/shared/shared.module';

import { ExtrapagesModule } from './extrapages/extrapages.module';

import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { initFirebaseBackend } from './authUtils';
import { CyptolandingComponent } from './cyptolanding/cyptolanding.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { FakeBackendInterceptor } from './core/helpers/fake-backend';
import { ConfigService } from './ConfigService';
import { LoadingService } from './shared/loading/loading.service';
import { TreeviewModule } from 'ngx-treeview-v2';
import { UIModule } from './shared/ui/ui.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

if (environment.defaultauth === 'firebase') {
  initFirebaseBackend(environment.firebaseConfig);
} else {
  // tslint:disable-next-line: no-unused-expression
  FakeBackendInterceptor;
}
function initializeApp(appConfig: ConfigService) {
  return () => appConfig.loadConfig();
}

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [

    AppComponent,
    CyptolandingComponent,
  ],
  imports: [
    BrowserModule,MatProgressSpinnerModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LayoutsModule,CalendarModule,
    AppRoutingModule,
    ExtrapagesModule,
    UIModule,FormsModule,
    //CarouselModule,
    NgbAccordionModule,TreeviewModule.forRoot(),
    NgbNavModule,
    NgbTooltipModule,
    SharedModule,LoadingModule,
    NgxScrollTopModule, RouterModule,
  ],
  bootstrap: [AppComponent],
  providers: [{  provide: APP_INITIALIZER,
    useFactory: initializeApp,
    deps:  [ConfigService],
    multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
    LoadingService],
})
export class AppModule { }
